export enum EsppQuoteType {
    NEW = 'NEW',
    ETE = 'EXTEND THE EXTENDED',
    USED = 'USED',
    REMANUFACTURED = 'VOLVO_REMANUFACTURED',
    REFURBISHED = 'VOLVO_REFURBISHED',
    NONE = 'NONE',
}